/**
 * Created by jiachenpan on 16/11/18.
 */

import dayjs from 'dayjs';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import weekDay from 'dayjs/plugin/weekday';
import localeData from 'dayjs/plugin/localeData';

dayjs.extend(weekOfYear);
dayjs.extend(weekDay);
dayjs.extend(localeData);

export function parseTime(time, cFormat) {
	if (arguments.length === 0) {
		return null;
	}
	const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
	let date;
	if (typeof time === 'object') {
		date = time;
	} else {
		if (('' + time).length === 10) time = parseInt(time) * 1000;
		date = new Date(time);
	}
	const formatObj = {
		y: date.getFullYear(),
		m: date.getMonth() + 1,
		d: date.getDate(),
		h: date.getHours(),
		i: date.getMinutes(),
		s: date.getSeconds(),
		a: date.getDay(),
	};
	const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
		let value = formatObj[key];
		if (key === 'a') return ['一', '二', '三', '四', '五', '六', '日'][value - 1];
		if (result.length > 0 && value < 10) {
			value = '0' + value;
		}
		return value || 0;
	});
	return time_str;
}

export function formatTime(time, option) {
	time = +time * 1000;
	const d = new Date(time);
	const now = Date.now();

	const diff = (now - d) / 1000;

	if (diff < 30) {
		return '刚刚';
	} else if (diff < 3600) {
		// less 1 hour
		return Math.ceil(diff / 60) + '分钟前';
	} else if (diff < 3600 * 24) {
		return Math.ceil(diff / 3600) + '小时前';
	} else if (diff < 3600 * 24 * 2) {
		return '1天前';
	}
	if (option) {
		return parseTime(time, option);
	} else {
		return (
			d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分'
		);
	}
}

// 格式化时间
export function getQueryObject(url) {
	url = url == null ? window.location.href : url;
	const search = url.substring(url.lastIndexOf('?') + 1);
	const obj = {};
	const reg = /([^?&=]+)=([^?&=]*)/g;
	search.replace(reg, (rs, $1, $2) => {
		const name = decodeURIComponent($1);
		let val = decodeURIComponent($2);
		val = String(val);
		obj[name] = val;
		return rs;
	});
	return obj;
}

/**
 *get getByteLen
 * @param {Sting} val input value
 * @returns {number} output value
 */
export function getByteLen(val) {
	let len = 0;
	for (let i = 0; i < val.length; i++) {
		// eslint-disable-next-line no-control-regex
		if (val[i].match(/[^\x00-\xff]/gi) != null) {
			len += 1;
		} else {
			len += 0.5;
		}
	}
	return Math.floor(len);
}

export function cleanArray(actual) {
	const newArray = [];
	for (let i = 0; i < actual.length; i++) {
		if (actual[i]) {
			newArray.push(actual[i]);
		}
	}
	return newArray;
}

export function param(json) {
	if (!json) return '';
	return cleanArray(
		Object.keys(json).map(key => {
			if (json[key] === undefined) return '';
			return encodeURIComponent(key) + '=' + encodeURIComponent(json[key]);
		})
	).join('&');
}

export function paramObj(url) {
	const queryIndex = url.indexOf('?');
	if (queryIndex === -1) {
		return {};
	}
	let hash;
	const myJson = {};
	const hashes = url.slice(queryIndex + 1).split('&');
	for (let i = 0; i < hashes.length; i++) {
		hash = hashes[i].split('=');
		myJson[hash[0]] = hash[1];
	}
	return myJson;
}
export function html2Text(val) {
	const div = document.createElement('div');
	div.innerHTML = val;
	return div.textContent || div.innerText;
}

export function objectMerge(target, source) {
	/* Merges two  objects,
     giving the last one precedence */

	if (typeof target !== 'object') {
		target = {};
	}
	if (Array.isArray(source)) {
		return source.slice();
	}
	for (const property in source) {
		// eslint-disable-next-line no-prototype-builtins
		if (source.hasOwnProperty(property)) {
			const sourceProperty = source[property];
			if (typeof sourceProperty === 'object') {
				target[property] = objectMerge(target[property], sourceProperty);
				continue;
			}
			target[property] = sourceProperty;
		}
	}
	return target;
}

export function scrollTo(element, to, duration) {
	if (duration <= 0) return;
	const difference = to - element.scrollTop;
	const perTick = (difference / duration) * 10;
	setTimeout(() => {
		element.scrollTop = element.scrollTop + perTick;
		if (element.scrollTop === to) return;
		scrollTo(element, to, duration - 10);
	}, 10);
}

export function toggleClass(element, className) {
	if (!element || !className) {
		return;
	}
	let classString = element.className;
	const nameIndex = classString.indexOf(className);
	if (nameIndex === -1) {
		classString += '' + className;
	} else {
		classString =
			classString.substr(0, nameIndex) + classString.substr(nameIndex + className.length);
	}
	element.className = classString;
}

export const pickerOptions = [
	{
		text: '今天',
		onClick(picker) {
			const end = new Date();
			const start = new Date(new Date().toDateString());
			end.setTime(start.getTime());
			picker.$emit('pick', [start, end]);
		},
	},
	{
		text: '最近一周',
		onClick(picker) {
			const end = new Date(new Date().toDateString());
			const start = new Date();
			start.setTime(end.getTime() - 3600 * 1000 * 24 * 7);
			picker.$emit('pick', [start, end]);
		},
	},
	{
		text: '最近一个月',
		onClick(picker) {
			const end = new Date(new Date().toDateString());
			const start = new Date();
			start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
			picker.$emit('pick', [start, end]);
		},
	},
	{
		text: '最近三个月',
		onClick(picker) {
			const end = new Date(new Date().toDateString());
			const start = new Date();
			start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
			picker.$emit('pick', [start, end]);
		},
	},
];

export function getTime(type) {
	if (type === 'start') {
		return new Date().getTime() - 3600 * 1000 * 24 * 90;
	} else {
		return new Date(new Date().toDateString());
	}
}

export function debounce(func, wait, immediate) {
	let timeout, args, context, timestamp, result;

	const later = function () {
		// 据上一次触发时间间隔
		const last = +new Date() - timestamp;

		// 上次被包装函数被调用时间间隔last小于设定时间间隔wait
		if (last < wait && last > 0) {
			timeout = setTimeout(later, wait - last);
		} else {
			timeout = null;
			// 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
			if (!immediate) {
				result = func.apply(context, args);
				if (!timeout) context = args = null;
			}
		}
	};

	return function (...args) {
		context = this;
		timestamp = +new Date();
		const callNow = immediate && !timeout;
		// 如果延时不存在，重新设定延时
		if (!timeout) timeout = setTimeout(later, wait);
		if (callNow) {
			result = func.apply(context, args);
			context = args = null;
		}

		return result;
	};
}

export function deepClone(source) {
	if (!source && typeof source !== 'object') {
		throw new Error('error arguments', 'shallowClone');
	}
	const targetObj = source.constructor === Array ? [] : {};
	for (const keys in source) {
		// eslint-disable-next-line no-prototype-builtins
		if (source.hasOwnProperty(keys)) {
			if (source[keys] && typeof source[keys] === 'object') {
				targetObj[keys] = source[keys].constructor === Array ? [] : {};
				targetObj[keys] = deepClone(source[keys]);
			} else {
				targetObj[keys] = source[keys];
			}
		}
	}
	return targetObj;
}

export function removeNull(list, key) {
	key = key || 'Children';
	if (Array.isArray(list)) {
		list.forEach(item => {
			if (item[key] && item[key].length == 0) {
				delete item[key];
			} else if (item[key] && item[key].length > 0) {
				removeNull(item[key], key);
			}
		});
	}
	return list;
}

// 获取上周时间范围
export function getWeekTime(type) {
	// 设置周一为每周的第一天（默认是周日）
	dayjs.locale('en', { weekStart: 1 }); // 设置为周一

	// 获取上一周的周一和周日
	const start = dayjs().subtract(1, 'week').startOf('week').format('YYYY-MM-DD');
	const end = dayjs().subtract(1, 'week').endOf('week').format('YYYY-MM-DD');

	let obj = {
		start,
		end,
	};

	return obj[type];
}

// 时间格式转换
export function transferDate(date) {
	// 年
	var year = date.getFullYear();
	// 月
	var month = date.getMonth() + 1;
	// 日
	var day = date.getDate();
	if (month >= 1 && month <= 9) {
		month = '0' + month;
	}
	if (day >= 0 && day <= 9) {
		day = '0' + day;
	}
	var dateString = year + '-' + month + '-' + day;
	return dateString;
}

// 获取近几个月的日期
export function GetMonthStr(num, type = 'month') {
	var d = new Date();
	d.setMonth(d.getMonth() - num);
	var yy1 = d.getFullYear();
	var mm1 = d.getMonth() + 1;
	var dd1 = d.getDate();
	if (mm1 < 10) {
		mm1 = '0' + mm1;
	}
	if (dd1 < 10) {
		dd1 = '0' + dd1;
	}
	let last;
	if (type == 'month') {
		last = `${yy1}-${mm1}-01`;
	}
	if (type == 'day') {
		last = `${yy1}-${mm1}-${dd1}`;
	}

	d = new Date();
	if (type == 'month') {
		d.setMonth(d.getMonth() - 1);
	}
	var yy2 = d.getFullYear();
	var mm2 = d.getMonth() + 1;
	var dd2;
	if (type == 'month') {
		dd2 = new Date(yy2, mm2, 0).getDate();
	}
	if (type == 'day') {
		dd2 = d.getDate();
	}
	if (mm2 < 10) {
		mm2 = '0' + mm2;
	}
	if (dd2 < 10) {
		dd2 = '0' + dd2;
	}

	let now = `${yy2}-${mm2}-${dd2}`;
	return { last, now };
}

//将秒数转换为时分秒格式
export function formatSeconds(value) {
	var theTime = parseInt(value); // 秒
	var middle = 0; // 分
	var hour = 0; // 小时

	if (theTime > 60) {
		middle = parseInt(theTime / 60);
		theTime = parseInt(theTime % 60);
		if (middle > 60) {
			hour = parseInt(middle / 60);
			middle = parseInt(middle % 60);
		}
	}
	var result = '' + parseInt(theTime) + '秒';
	if (middle > 0) {
		result = '' + parseInt(middle) + '分' + result;
	}
	if (hour > 0) {
		result = '' + parseInt(hour) + '小时' + result;
	}
	return result;
}

// 空值判断
export function judgeNullValue(v) {
	switch (typeof v) {
		case 'undefined':
			return true;
		case 'string':
			if (v.replace(/(^[ \t\n\r]*)|([ \t\n\r]*$)/g, '').length == 0) {
				return true;
			}
			break;
		case 'boolean':
			if (!v) return true;
			break;
		case 'object':
			if (v === null || v.length === 0) return true;
			for (var i in v) {
				return false;
			}
			return true;
	}
	return false;
}

export function platformFilter(status) {
	// 网站管理（建站平台为易营宝时展示）
	// 1-建站供应商/2-外贸云建站/3-客户自有网站
	return function ({ orderplatform }) {
		if (status === 2) {
			return orderplatform.status && !orderplatform.isConfirm && orderplatform.status !== status;
		} else {
			return orderplatform.status && orderplatform.status !== status;
		}
	};
}

export function judgeObj(obj1, obj2) {
	var obj1keys = Object.keys(obj1);
	var obj2keys = Object.keys(obj2);

	if (obj2keys.length !== obj1keys.length) return false;

	for (let i = 0; i <= obj1keys.length - 1; i++) {
		let key = obj1keys[i];
		if (!obj2keys.includes(key)) return false;
		if (obj2[key] !== obj1[key]) return false;
	}
	return true;
}

// 内存路径转file对象
export function dataURLtoFile(dataurl, filename) {
	var arr = dataurl.split(','),
		mime = arr[0].match(/:(.*?);/)[1],
		bstr = atob(arr[1]),
		n = bstr.length,
		u8arr = new Uint8Array(n);
	while (n--) {
		u8arr[n] = bstr.charCodeAt(n);
	}
	return new File([u8arr], filename, { type: mime });
}

// 双向映射
export function biMap(arr, key = 'label', val = 'value') {
	let valueToLabel = {};

	for (let item of arr) {
		valueToLabel[item[key]] = item[val];
	}

	return valueToLabel;
}

// 删掉树形数据里children为空的children
export function removeTreeEmpty(data, props = 'children') {
	if (data && data.length) {
		data.forEach(item => {
			if (item[props] && item[props].length) {
				removeTreeEmpty(item[props], props);
			} else {
				delete item[props];
			}
		});
		return data;
	} else {
		return [];
	}
}

// 添加修改某个属性值
export function editTreeAttr(data, props = 'children', attr, arr) {
	if (data && data.length) {
		data.forEach(item => {
			if (item[attr] === null) {
				item[attr] = arr[0] + item[arr[1]];
				if (item[props] && item[props].length) {
					editTreeAttr(item[props], props, attr, arr);
				}
			}
		});
		return data;
	} else {
		return [];
	}
}

// 将树形数据平铺
export function treeToArray(tree, child) {
	let arr = [];
	const expanded = datas => {
		if (datas && datas.length > 0) {
			datas.forEach(e => {
				arr.push(e);
				expanded(e[child]);
			});
		}
	};
	expanded(tree);
	return arr;
}

// 获取选中的node节点集合（不包括全选）
export function getCollectionCheckedNodesNoAll(nodeList) {
	let data = nodeList.filter(item => item.value !== 'all');
	// 全选后只保留父节点
	// 改为全选剔除父节点
	data.forEach(child => {
		if (child.checked && child.parent && child.parent.checked) {
			let ids = child.parent.children.map(item => item.value);
			data = data.filter(item => ids.indexOf(item.value) != -1);
		}
	});
	return data;
}

// 根据父级id找到最后一集所有子集id
export function getLastChildrenIdsByParentId(refs, parentId) {
	// 获取所有已选节点
	let nodeList = refs.getCheckedNodes();
	// 找到 parentId 节点
	let list = nodeList.filter(item => item.value === parentId);
	// 遍历node节点找寻最后一级的所有子集id
	const getLastChildrenIds = function (list, data = []) {
		list.forEach(item => {
			if (item.hasChildren) {
				getLastChildrenIds(item.children, data);
			} else {
				data.push(item.value);
			}
		});
		return data;
	};
	return getLastChildrenIds(list);
}

// 是否数组类型
export function isArray(val) {
	return Object.prototype.toString.call(val) === '[object Array]';
}

// 是否函数
export function isFunction(val) {
	return Object.prototype.toString.call(val) === '[object Function]';
}

// 数组内是否存在该项
export function isHave(val, data) {
	if (isArray(val)) {
		return val.every(item => data.indexOf(item) !== -1);
	} else {
		return data.indexOf(val) !== -1;
	}
}

// 数组对象内是否存在该项
export function isHaveItem(data, val, key) {
	return data.some(item => val.indexOf(item[key]) != -1);
}
